import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthenticationService } from "../../services";
import { useSelector } from "react-redux";

export const ApplicationsContext = createContext({
  applications: [],
});

export const ApplicationsProvider = ({ children }) => {
  const { user } = useSelector((state) => state.authentication);
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const _fetch = async () => {
      try {
        const { data } = await AuthenticationService.getApplications();
        setApplications(data);
      } catch (err) {
        console.log(err);
      }
    };

    if (user) {
      _fetch();
    }
  }, [user]);

  return (
    <ApplicationsContext.Provider value={{ applications }}>
      {children}
    </ApplicationsContext.Provider>
  )
};

export const useApplications = () => {
  const value = useContext(ApplicationsContext);
  return value;
}
